import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=568ddaf4&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=568ddaf4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568ddaf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('568ddaf4')) {
      api.createRecord('568ddaf4', component.options)
    } else {
      api.reload('568ddaf4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=568ddaf4&scoped=true", function () {
      api.rerender('568ddaf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/assetManagement/platformAccount/detail.vue"
export default component.exports